import type * as AdPlayerBitmovinBundle from '@foundation-player/ad-player-bitmovin';
import type * as AdPlayerNativeBundle from '@foundation-player/ad-player-native';
import type * as AdvertisingBundle from '@foundation-player/plugin-advertising';
import { AdPlayerType, PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

type AdPlayerBundle = typeof AdPlayerBitmovinBundle | typeof AdPlayerNativeBundle;

export const createAdvertisingPlugin: PluginFactoryFunction = (builderConfig) => {
  const packages: PackageName[] = [];
  let adPlayer: PackageName;

  switch (builderConfig.adPlayerType) {
    case AdPlayerType.Bitmovin:
      adPlayer = PackageName.AdPlayerBitmovin;
      break;
    case AdPlayerType.Native:
      adPlayer = PackageName.AdPlayerNative;
      break;
    default:
      console.error('Cannot enable advertising without an ad player');
      return undefined;
  }

  packages.push(adPlayer);
  packages.push(PackageName.PluginAdvertising);

  return [
    packages,
    () => {
      const adPlayerConstructor = resolveByPackageNameOrThrow<AdPlayerBundle>(adPlayer).createAdPlayer;
      const advertisingGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[PackageName.PluginAdvertising];
      return [
        new (resolveByPackageNameOrThrow<typeof AdvertisingBundle>(PackageName.PluginAdvertising).AdvertisingPlugin)(
          adPlayerConstructor,
          builderConfig.pluginConfigs[advertisingGlobalName] as AdvertisingBundle.PluginConfig,
        ),
      ];
    },
  ];
};
